import { createStore, applyMiddleware, combineReducers, compose } from "redux";
import * as reducers from "./ducks"; // import all reducers from ducks/index.js
import logger from "redux-logger";
import { RootState as AppRootState } from "../types/redux";

// Redux DevToolsの拡張機能の型定義
declare global {
  interface Window {
    __REDUX_DEVTOOLS_EXTENSION_COMPOSE__?: typeof compose;
  }
}

function store(initialState = {}) {
  const rootReducer = combineReducers(reducers);

  // Redux DevTools拡張機能を使用するためのコンポーザー
  const composeEnhancers =
    window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || compose;

  return createStore(
    rootReducer,
    initialState,
    composeEnhancers(applyMiddleware(logger))
  );
}

export type RootState = AppRootState;
export type AppDispatch = ReturnType<typeof store>["dispatch"];

export default store;
